<template>
  <v-app>
    <v-navigation-drawer dark clipped overflow v-model="sidebar" app class="teal darken-2">
      <p class="text-xs-center hidden-lg-and-up mt-3">
        <img src="/img/logo.png" style="width: 80%;" alt="Logo do Orçamento Forrageiro" />
      </p>

      <user-wrapper class="hidden-md-and-up"></user-wrapper>

      <menu-wrapper @clicked="menu" :synchronized="synchronized"></menu-wrapper>

      <p class="text-xs-center hidden-md-and-up mt-3">
        <img src="/img/partners-white.png" style="width: 60%;" alt="Logo da Embrapa e CNA" />
      </p>

      <p class="text-xs-center hidden-sm-and-down" style="position: absolute; bottom: 0;">
        <img src="/img/partners-white.png" style="width: 60%;" alt="Logo da Embrapa e CNA" />
      </p>
    </v-navigation-drawer>

    <v-toolbar app clipped-left dark color="teal darken-3">
      <v-toolbar-side-icon @click.stop="sidebar = !sidebar"></v-toolbar-side-icon>
      <v-toolbar-title
        v-text="'Simulações'"
      ></v-toolbar-title>
      <v-spacer class="hidden-sm-and-down"></v-spacer>

      <v-text-field
        v-if="simulations && simulations.length > 0"
        append-icon="search"
        label="Buscar..."
        single-line
        hide-details
        v-model="search"
        class="mx-2 hidden-sm-and-down"
        color="white"
      />

      <div class="d-flex align-center" style="margin-left: auto">
        <user-wrapper class="hidden-sm-and-down"></user-wrapper>
      </div>
    </v-toolbar>

    <v-content>
      <v-container fluid grid-list-lg>
        <v-layout row wrap v-if="!simulations || simulations.length === 0">
          <v-flex xs12 sm12 md10 offset-md1 lg8 offset-lg2 xl6 offset-xl3 class="my-3">
            <v-card class="px-3 py-2">
              <v-card-title primary-title>
                <div class="headline">Bem vind@!</div>
              </v-card-title>
              <v-card-text>
                <p>
                  Este aplicativo é um simulador do
                  <strong>CustoBov</strong> para controle de custos e margens da bovinocultura de corte.
                </p>
                <p>CustoBov é um novo aplicativo desenvolvido para facilitar a administração das fazendas de gado de corte, de modo a contribuir para a elevação da rentabilidade da atividade. Sua principal funcionalidade é controlar os custos de produção da bovinocultura e as margens que refletem seu desempenho econômico.</p>
                <p>O CustoBov foi desenvolvido buscando a maior simplicidade possível, tendo sido estruturado de forma que os usuários obtenham resultados mesmo quando não contam com dados detalhados sobre cada componente do sistema de produção.</p>
                <p>O aplicativo permite representar diferentes fazendas ou diferentes anos para uma mesma fazenda. Embora o aplicativo seja primordialmente uma ferramenta de controle voltada para avaliar situações reais, também é possível usá-la para simular diferentes conjunturas, auxiliando nos processos de planejamento e tomada de decisões.</p>
                <p>Este aplicativo foi uma demanda apontada por pecuaristas e técnicos que buscavam uma forma simples e eficiente de apurar os custos de produção e outros indicadores econômicos da atividade pecuária. Acredita-se que este aplicativo, irá ajudar significativamente na melhoria da gestão do negócio pecuário, contribuindo para a elevação da rentabilidade da atividade.</p>
                <p>
                  <strong>Atenção!</strong> Você ainda não possui nenhuma simulação criada. Para começar a utilizar o aplicativo,
                  <strong>clique no botão abaixo para fazer sua primeira simulação!</strong>
                </p>
              </v-card-text>
              <v-card-actions class="hidden-sm-and-down">
                <v-spacer></v-spacer>
                <v-btn dark color="teal darken-3" @click.stop="dialogs.create = !dialogs.create">
                  <v-icon left >add</v-icon>Nova Simulação
                </v-btn>
              </v-card-actions>

              <v-card-actions class="hidden-md-and-up">
                <v-layout row wrap class="mx-1 my-2">
                  <v-flex xs12>
                    <v-btn color="primary" block @click.stop="dialogs.create = !dialogs.create">
                      <v-icon left>add</v-icon>Nova Simulação
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <p class="text-xs-center my-4 hidden-md-and-up">
              <img src="/img/partners.png" style="width: 300px;" alt="Logo da Embrapa" />
            </p>

            <p class="text-xs-center my-4 hidden-sm-and-down">
              <img src="/img/partners.png" style="width: 600px;" alt="Logo da Embrapa" />
            </p>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex
            xs12
            class="hidden-md-and-up mt-0 pt-0"
            v-if="simulations && simulations.length > 3"
          >
            <v-text-field
              append-icon="search"
              label="Buscar..."
              single-line
              hide-details
              v-model="search"
            />
          </v-flex>

          <v-flex
            xs12
            sm12
            md6
            lg6
            xl4
            class="px-2"
            v-for="s in filteredSimulations"
            :key="s['code']"
          >
            {{ validated = validateHelper(s) | hack }}
            <v-card class="pb-2">
              <v-card-title primary-title>
                <div class="headline">{{ s.label }}</div>
                <v-spacer></v-spacer>
                <v-icon
                  v-html="validated ? (s.changed > synchronized ? 'cloud_upload' : 'cloud_done') : 'edit'"
                  color="grey lighten-1"
                ></v-icon>
              </v-card-title>
              <v-card-text>
                Propriedade
                <strong>{{ s.dadosIniciais.farm || 'N/A' }}</strong>, em
                <strong>{{ s.dadosIniciais.city || 'N/A' }} - {{ uf(s.dadosIniciais.state ) || 'N/A' }}</strong>, com
                <strong>{{ s.dadosIniciais.size | formatNumber }} ha</strong>. Editada em
                <strong>{{ s.updated | formatDate }}</strong>.
              </v-card-text>
              <v-card-text v-if="validated.all" class="px-2 py-0">
                {{ balance = balanceHelper(s) | hack }}
                {{ source = sourceHelper(s) | hack }}
                {{ stats = finalStatsHelper(balance, source) | hack }}
                <v-alert
                  :value="true"
                  outline
                  :color="stats.final < 0 ? 'error' : 'success'"
                  :icon="stats.final > 0 ? 'thumb_up' : 'thumb_down'"
                >
                  Forragem&nbsp;
                  <strong>{{ stats.final &lt; 0 ? 'deficitária' : 'excedente' }}</strong>&nbsp;em&nbsp;
                  <strong>{{ stats.lower &lt; 0 ? stats.final : stats.lower | formatNumber }} {{ stats.lower &lt; 0 ? 'Kg/ano' : 'Kg/mês' }}</strong>!
                </v-alert>
              </v-card-text>
              <v-card-actions class="px-2">
                <v-layout row wrap>
                  <v-flex xs6 sm3>
                    <v-btn
                      color="yellow darken-3"
                      class="white--text"
                      style="min-width: 50px;"
                      @click="chart(s)"
                      block
                      large
                    >
                      <v-icon dark>insert_chart</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-btn
                      color="light-blue darken-3"
                      class="white--text"
                      style="min-width: 50px;"
                      @click="edit(s)"
                      block
                      large
                    >
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-btn
                      color="deep-purple darken-3"
                      class="white--text"
                      style="min-width: 50px;"
                      @click="copy(s)"
                      block
                      large
                    >
                      <v-icon dark>content_copy</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-btn
                      color="red darken-3"
                      class="white--text"
                      style="min-width: 50px;"
                      @click="remove(s)"
                      block
                      large
                    >
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>

          <v-flex
            xs12
            class="px-2"
            v-if="simulations && simulations.length > 0 && filteredSimulations.length === 0"
          >
            <v-alert
              :value="true"
              type="warning"
            >Sua busca com o termo "{{ search }}" não retornou resultados!</v-alert>
          </v-flex>
        </v-layout>

        <v-btn
          fab
          bottom
          right
          color="light-blue"
          dark
          fixed
          v-if="simulations && simulations.length > 0"
          @click.stop="dialogs.create = !dialogs.create"
        >
          <v-icon>add</v-icon>
        </v-btn>
        <v-dialog v-model="dialogs.create" min-width="250px" max-width="500px">
          <v-card>
            <v-card-title class="grey lighten-4 py-4 title">Criar Simulação</v-card-title>
            <v-container>
              <v-form ref="form">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="name"
                      label="Nome da Simulação"
                      :counter="15"
                      :rules="rules.name"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" @click="dialogs.create = false">Cancelar</v-btn>
              <v-btn color="success" @click="create">Criar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <confirm-wrapper ref="confirm" />

        <message-wrapper ref="message" />

        <v-dialog v-model="wait" persistent max-width="300px">
          <v-card>
            <v-card-text style="text-align: center;">
              <v-progress-circular
                :size="100"
                :width="15"
                :rotate="360"
                :value="progress"
                color="teal"
              >{{ progress }}%</v-progress-circular>
            </v-card-text>
            <v-card-title
              class="headline"
              block
              style="text-align: center;"
            >Sincronizando... por favor, aguarde!</v-card-title>
          </v-card>
        </v-dialog>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable */
import manifest from "../../public/manifest.json";
import brazil from "../assets/brazil.json";
import { uuid } from "vue-idb";
import contracts from "../contracts";
import moment from "moment";
import axios from "axios";
import timestamp from "unix-timestamp";
import crypto from "crypto-js";
import query from "querystring";

import UserWrapper from "../components/User.vue";
import ConfirmWrapper from "../components/Confirm.vue";
import MessageWrapper from "../components/Message.vue";
import MenuWrapper from "../components/Menu.vue";

import UtilHelper from "../helpers/util";
import SimulatorHelper from "../helpers/simulator";

var settings = require("../settings/" + process.env.NODE_ENV + ".json");

export default {
  components: {
    UserWrapper,
    ConfirmWrapper,
    MessageWrapper,
    MenuWrapper
  },
  mixins: [UtilHelper, SimulatorHelper],
  data() {
    return {
      manifest: manifest,
      sidebar: false,
      wait: false,
      progress: 0,
      dialogs: {
        create: false,
        delete: false
      },
      valid: false,
      user: null,
      settings: settings,
      search: "",
      simulations: null,
      name: "",
      rules: {
        name: [
          v =>
            (v && v.trim().length > 0) || "Insira um nome para sua simulação!",
          v =>
            (v && v.length < 16) || "O nome não pode ter mais de 15 caracteres!"
        ],
        type: [v => contracts.hasOwnProperty(v) || "Escolha um tipo válido!"]
      },
      type: '',
      tocompare: [],
      hold: 0,
      release: 0,
      original: {},
      copyDialog: false,
      backup: [],
      synchronized: null
    };
  },
  beforeCreate() {
    if (!this.$localStorage.get("user").authenticated) {
      this.$router.push("/");
    }
  },
  created() {
    this.user = this.$localStorage.get("user");
  },
  mounted() {
    if (this.user.authenticated) {
      this.synchronized = this.$localStorage.get("synchronized");

      var alwaysSync = this.$localStorage.get("alwaysSync");

      if (this.$root.$data.trySync || alwaysSync) {
        this.sync();
      } else {
        this.refresh();
      }
    }
  },
  methods: {
    newSimulation() {
      if (this.user != null) {
        this.dialogs.create = true;
      }
    },
    refresh() {
      this.dialogs.create = false;

      this.name = "";

      this.$db.simulation
        .where("active")
        .equals(1)
        .reverse()
        .sortBy("updated")
        .then(simulations => {
          this.simulations = simulations;
        });
    },
    sync() {
      this.wait = true;

      var self = this;

      var err = function(error) {
        console.log(error);

        self.$root.$data.trySync = false;

        self.wait = false;

        self.refresh();

        self.$refs.message.open(
          "Atenção! Erro ao tentar sincronizar. Por favor, tente novamente mais tarde.",
          "error"
        );

        self.$err(error)
      };

      var now = Math.floor(timestamp.now())

      var ts = this.$localStorage.get('synchronized')

      var lastSync = timestamp.toDate(ts)

      self.progress = 5;

      console.log("#1 - Trying to connect in remote server.");

      axios
        .get(settings.api + "/status", { timeout: 2000 })
        .then(function(response) {
          self.progress = 15;

          console.log(
            "#2 - Getting from local DB all items edited from last sync: " +
              lastSync
          );
          self.$db.simulation
          .where('changed')
          .above(lastSync)
          .toArray()
          .then(simulations => {
              let promises = [];
              
              simulations.forEach(s => {
                promises.push(axios.post(settings.api + '/simulation', s, { headers: { Authorization: 'Bearer ' + self.user.token } }))
              })

              console.log(
                "#3 - Sending all items edited from last sync: " +
                  promises.length
              );

              axios
                .all(promises)
                .then(function(results) {
                  results.forEach(r => {
                    console.log(r.data);
                  });

                  self.progress = 50;

                  console.log(
                    "#4 - Geting all items in server from last sync. Last sync in timestamp: " +
                      timestamp.fromDate(lastSync)
                  );

                  axios
                    .get(
                      settings.api +
                        "/simulations/" +
                        timestamp.fromDate(lastSync),
                      {
                        headers: { Authorization: "Bearer " + self.user.token }
                      }
                    )
                    .then(response => {
                      self.progress = 80;

                      var items = response.data;

                      items.forEach(i => {
                        console.log("Getted: " + i.code + "!");
                        console.log(i);
                      });

                      console.log(
                        "#5 - Saving all items getted from server and deleting inactivated items."
                      );

                      self.$db
                        .transaction("rw", self.$db.simulation, () => {
                          items.forEach(d => {
                            d.created = new Date(d.created);
                            d.changed = new Date(d.changed);

                            self.$db.simulation.put(d);
                          });

                          self.$db.simulation
                            .where("active")
                            .equals(0)
                            .delete();
                        })
                        .then(result => {
                          console.log(
                            "#6 - All done! Updating control variables: " +
                              timestamp.toDate(now)
                          );

                          self.$localStorage.set('synchronized', now)

                          self.synchronized = now

                          self.$root.$data.trySync = false

                          self.progress = 100

                          self.refresh()

                          setTimeout(function () {
                            self.wait = false

                            self.$refs.message.open('Sincronização realizada com sucesso!', 'success')
                          }, 300)
                        })
                        .catch(err);
                    })
                    .catch(err);
                })
                .catch(err);
            })
            .catch(err);
        })
        .catch(error => {
          console.log(error);

          self.$root.$data.trySync = false;

          self.wait = false;

          self.refresh();

          self.$refs.message.open(
            "Atenção! O servidor remoto parece estar indisponível para sincronização dos dados. Por favor, verifique sua conexão com a internet ou tente novamente mais tarde.",
            "yellow darken-3",
            6000
          );
        });
    },
    create() {
      if (this.$refs.form.validate()) {
        var s = this.instantiateSimulationHelper();

        s.code = uuid();
        s.label = this.name;
        s.created = timestamp.fromDate(new Date());
        s.updated = timestamp.fromDate(new Date());
        s.active = 1;
        s.rebanhoReproducao = 1;
        s.rebanhoRecria = 1;
        s.bovinoAbate = 1;
        s.bovinoOutro = 1;
        s.proLabore = 1;
        s.outrasReceitas = 1;
        s.dadosDasDespesas = 1;
        s.dadosManutencao = 1;
        s.dadosDespesasAnimal = 1;
        s.dadosDespesasServicos = 1;
        s.dadosRecursosPastagensOutros = 1;
        s.dadosRecursosInstalacoes = 1;
        s.dadosRecursosMaquinas = 1;
        s.dadosRecursosAnimais = 1;

        this.$db.simulation
          .add(s)
          .then(() => this.$router.push({ path: "/simulation/" + s.code }));
      }
    },
    chart(simulation) {
      this.$router.push({ path: "/graficos/" + simulation.code });
    },
    edit(simulation) {
      this.$router.push({ path: "/simulation/" + simulation.code });
    },
    copy(simulation) {
      this.$refs.confirm
        .open(
          "Copiar Simulação",
          'Tem certeza de que deseja duplicar a simulação "' +
            simulation.label +
            '"?',
          {
            color: "deep-purple darken-3"
          }
        )
        .then(confirm => {
          if (confirm) {
            var s = JSON.parse(JSON.stringify(simulation));

            s.code = uuid();
            s.label = s.label.substr(0, 13) + " 2";
            s.updated = timestamp.fromDate(new Date());
            s.active = 1;

            this.$db.simulation
              .add(s)
              .then(() => this.$router.push({ path: "/simulation/" + s.code }));
          }
        });
    },
    remove(simulation) {
      this.$refs.confirm
        .open(
          "Apagar Simulação",
          'Tem certeza de que deseja apagar a simulação "' +
            simulation.label +
            '"? Esta ação é irreversível!',
          { color: "red" }
        )
        .then(confirm => {
          if (confirm) {
            simulation.active = 0;
            simulation.updated = timestamp.fromDate(new Date());

            this.$db.simulation
              .where("code")
              .equals(simulation.code)
              .modify(simulation)
              .then(() => {
                this.refresh();
                this.$refs.message.open(
                  "Simulação apagada com sucesso!",
                  "success"
                );
              });
          }
        });
    },
    uf(state) {
      for (var i = 0; i < brazil.states.length; i++) {
        if (brazil.states[i].name === state) {
          return brazil.states[i].uf;
        }
      }

      return null;
    },
    menu(choose) {
      console.log("Menu option choosed: " + choose);

      switch (choose) {
        case "Sincronizar":
          this.sidebar = false;

          this.sync();

          break;

        case "Configurações":
          this.sidebar = false;

          this.$router.push({ path: "/settings" });

          break;

        case "Sobre":
          this.sidebar = false;

          this.$router.push({ path: "/about" });

          break;
      }
    }
  },
  computed: {
    filteredSimulations() {
      if (!this.search || /^\s*$/.test(this.search)) {
        return this.simulations;
      } else {
        var self = this;

        return this.simulations.filter(function(s) {
          return self._.includes(
            s.label.toLowerCase(),
            self.search.toLowerCase()
          );
        });
      }
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return "";

      return moment(timestamp.toDate(value)).format("D/M/YY HH:mm");
    },
    formatNumber(value) {
      return Number(Math.round(value)).toLocaleString("pt-BR");
    },
    hack(value) {
      return "";
    }
  }
};
</script>
